import React from "react";
import AftersaleConfigEdit from 'containers/aftersale/aftersaleConfigEdit';
import axios from 'axios';
import '../../form.css';

import { Table, Typography, Button, Layout, Row, Col, Divider, Spin, Space, Popconfirm, message, Form, Input } from 'antd';
import {
    DeleteOutlined,
    EditOutlined,
    PlusOutlined,
    ReloadOutlined,
    SearchOutlined,
} from '@ant-design/icons';
import { Link } from "react-router-dom";

const { Content } = Layout;
const { Title } = Typography;

export default class MemberList extends React.Component {

    constructor(props: any) {
        super(props);
        this.getMembers();
    }

    state = {
        memberData: [],
        userInfo: [],
        loading: true,
        total: 0,
        dataId: 0,
        editorVisible: false,
        editorTitle: "Modal Title"
    };

    getMembers = () => {
        axios.get('https://www.fastmock.site/mock/9973669a2a13cbb70690fdf6f1880e97/admin/aftersaleConfig/list', {
            params: {}
        })
            .then((res) => {
                console.log('res', res.data.data.list)
                this.setState({
                    memberData: res.data.data.list,
                    total: res.data.data.total,
                    loading: false
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    columns = [
        {
            title: 'ID',
            dataIndex: 'id'
        },
        {
            title: '申请类型',
            dataIndex: 'type',
        },
        {
            title: '原因分类',
            dataIndex: 'reasonCategory',
        },
        {
            title: '原因',
            dataIndex: 'reason',
        },
        {
            title: '操作',
            dataIndex: 'id',
            render: (text: number) =>
                <Space>
                    <Button type="primary" shape="round" onClick={this.editData.bind(this, text)}><EditOutlined />编辑</Button>
                    <Popconfirm placement="left" title="确认删除此条记录吗？" onConfirm={this.deleteConfirm.bind(this, text)} okText="确认" cancelText="取消">
                        <Button shape="round" ><DeleteOutlined />删除</Button>
                    </Popconfirm>
                </Space>
            ,
        }
    ];

    cancelModal = () => {
        this.setState({
            editorVisible: false,
        });
    };

    createData = () => {
        this.setState({
            editorVisible: true,
            editorTitle: "新增配置"
        });
    };

    editData = (text: number): any => {
        this.setState({
            dataId: text,
            editorVisible: true,
            editorTitle: "编辑配置 ID - " + text.toString()
        });
    }

    deleteConfirm = (text: number): any => {
        message.warning("删除了id" + text.toString());
    }

    render() {
        let userInfo: any = this.state.userInfo;
        console.log('userInfo', userInfo);
        return (
            <div>
                <div className="page-title">
                    <Title level={3}>售后配置</Title>
                </div>

                <Divider />

                <Row gutter={[18, 24]}>
                    <Col><Button type="primary" onClick={this.createData}><PlusOutlined /> 新增配置</Button></Col>
                    <Col>
                        <Form
                            layout="inline"
                        >
                            <Form.Item>
                                <Input placeholder="类型、分类、原因" />
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" htmlType="submit"><SearchOutlined />搜索</Button>
                            </Form.Item>
                        </Form>
                    </Col>
                    <Col><Button onClick={() => { window.location.reload() }} ><ReloadOutlined /> 刷新</Button></Col>
                </Row>
                <Spin tip="Loading..." size="large" spinning={this.state.loading}>
                    <Table
                        columns={this.columns}
                        dataSource={this.state.memberData}
                        pagination={{
                            total: this.state.total,
                            position: ["bottomLeft"],
                        }}
                    />
                </Spin>
                <AftersaleConfigEdit dataId={this.state.dataId} editorVisible={this.state.editorVisible} editorTitle={this.state.editorTitle} onCancel={this.cancelModal} ref="child" />
            </div>
        );
    }
}
